import { useEffect } from "react";
import { Link } from "react-router-dom";
import { captureAttribution, trackMarketingEvent } from "@/lib/marketingAnalytics";

export default function Challenge() {
  useEffect(() => {
    captureAttribution();
    trackMarketingEvent("challenge_view");
  }, []);

  const track = (action) => trackMarketingEvent("challenge_cta_click", { action });

  return (
    <main className="min-h-screen bg-slate-950 text-white">
      <section className="mx-auto max-w-5xl px-6 py-16 md:py-24">
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">GamePlatPlay Challenge</p>
        <h1 className="max-w-4xl text-4xl font-black leading-tight md:text-7xl">Play. Compete. Get Better.</h1>
        <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
          Enter a GamePlatPlay challenge, test your strategy, climb the leaderboard, and use Yorick to sharpen your next move.
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Link to="/tournaments" onClick={() => track("explore_tournaments")} className="rounded-lg bg-white px-6 py-3 text-center font-bold text-slate-950">
            Explore Tournaments
          </Link>
          <Link to="/balatro" onClick={() => track("try_strategy")} className="rounded-lg border border-slate-600 px-6 py-3 text-center font-bold text-white">
            Improve Your Strategy
          </Link>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-3">
          <article className="rounded-xl border border-slate-800 bg-slate-900/60 p-6"><h2 className="text-xl font-bold">1. Pick a challenge</h2><p className="mt-2 text-slate-300">Choose an upcoming competition and review the rules before you play.</p></article>
          <article className="rounded-xl border border-slate-800 bg-slate-900/60 p-6"><h2 className="text-xl font-bold">2. Make your run</h2><p className="mt-2 text-slate-300">Compete, improve your score, and learn which decisions move you up the board.</p></article>
          <article className="rounded-xl border border-slate-800 bg-slate-900/60 p-6"><h2 className="text-xl font-bold">3. Come back stronger</h2><p className="mt-2 text-slate-300">Check the leaderboard and use Yorick-powered strategy content to prepare for your next attempt.</p></article>
        </div>
      </section>
    </main>
  );
}
